import React from 'react';

function ListPagination({ paginationData, onPageChange }) {
    const { current_page, total_pages } = paginationData;
    const maxVisiblePages = 5;

    const goToPage = (page) => {
        if (page >= 1 && page <= total_pages) {
            onPageChange(page);
        }
    };

    const renderPageNumbers = () => {
        let pages = [];
        let startPage = Math.max(1, current_page - 2);
        let endPage = Math.min(total_pages, startPage + maxVisiblePages - 1);

        if (startPage > 1) pages.push(<span key="start">...</span>);

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <button
                    key={i}
                    className={`sl-p-2 sl-mx-1 ${i === current_page ? "active sl-font-bold sl-underline" : ""}`}
                    onClick={() => goToPage(i)}
                >
                    {i}
                </button>
            );
        }

        if (endPage < total_pages) pages.push(<span key="end">...</span>);

        return pages;
    };

    return (
        <div className={'sl-m-auto'}>
            <div className="pagination-container sl-flex sl-items-center sl-gap-2 sl-mt-4">
                <button className="sl-p-2" disabled={current_page === 1}
                        onClick={() => goToPage(1)}>First
                </button>

                <button className="sl-p-2" disabled={current_page === 1}
                        onClick={() => goToPage(current_page - 1)}>Prev
                </button>

                {renderPageNumbers()}

                <button className="sl-p-2" disabled={current_page === total_pages}
                        onClick={() => goToPage(current_page + 1)}>Next
                </button>

                <button className="sl-p-2" disabled={current_page === total_pages}
                        onClick={() => goToPage(total_pages)}>Last
                </button>
            </div>
        </div>
    );
}

export default ListPagination;
